
import { Button } from "@/components/ui/button";

interface MeetingDetails {
  dateTime: Date | null;
  attendeeName: string | null;
  duration?: number;
}

interface ScheduleButtonProps {
  isAuthenticated: boolean;
  isLoading: boolean;
  isDisabled: boolean;
  onGoogleSignIn: () => void;
  onSchedule: () => void;
  meetingDetails: MeetingDetails;
}

const ScheduleButton = ({
  isAuthenticated,
  isLoading,
  isDisabled,
  onGoogleSignIn,
  onSchedule,
  meetingDetails
}: ScheduleButtonProps) => {
  const handleClick = () => {
    console.log("Schedule button clicked", {
      isAuthenticated,
      isLoading,
      hasDetails: !!meetingDetails
    });
    
    if (!isAuthenticated) {
      console.log("Not authenticated, triggering Google sign in");
      onGoogleSignIn();
    } else {
      console.log("Authenticated, proceeding with scheduling");
      onSchedule();
    }
  };

  if (!isAuthenticated) {
    return (
      <Button
        onClick={handleClick}
        disabled={isDisabled || isLoading}
        className="w-full bg-white hover:bg-gray-100 text-gray-800 font-semibold border border-gray-400 flex items-center justify-center gap-2"
      >
        <img 
          src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg" 
          alt="Google Logo" 
          className="w-5 h-5"
        />
        Continue with Google
      </Button>
    );
  }

  return (
    <Button
      onClick={handleClick}
      disabled={isDisabled || isLoading}
      className="w-full"
    >
      {isLoading ? "Loading..." : "Schedule Meeting"}
    </Button>
  );
};

export default ScheduleButton;
